import { createSlice } from "@reduxjs/toolkit";
import { response } from "express";

const initialState = {
  loading: false,
  success: false,
  hasData: false,
  errorMessage: "",
  error: false,
  data: {
    liveOfferDetails:[]
  },
};


const liveOffersListSlice = createSlice({
  name: "liveOffers", // Slice name
  initialState, // Initial state
  reducers: {
    // Reducer functions to update the state
    fetchLiveOffers(state, action) {
      state.loading = true;
      state.success = false;
      state.data = initialState.data;
      state.errorMessage = "";
      
      state.error = false;
      state.hasData = false;
    },
    fetchLiveOffersSuccess(state, action) {
      state.loading = false;
      state.success = true;
      state.data = action.payload ?? {};
      state.errorMessage = "";
      state.error = false;
      state.hasData = true;
    },
    fetchLiveOffersFailure(state, action) {
      state.loading = false;
      state.success = false;
      state.data = initialState.data;
      state.errorMessage = action.payload ?? "something went wrong";
      state.error = true;
      state.hasData = false;
    }
  },
});

// Export the reducer functions as actions
export const {
  fetchLiveOffers,
  fetchLiveOffersSuccess,
  fetchLiveOffersFailure,
} = liveOffersListSlice.actions;
// Export the reducer function itself
export default liveOffersListSlice.reducer;
